<template>
  <div class="chart-container">
    <Bar :data="props.data" :options="chartOptions" />
  </div>
</template>

<script setup lang="ts">
import _ from "lodash";
import { computed } from "vue";
import { Bar } from "vue-chartjs";
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, elements } from 'chart.js'
import { useDark } from "@vueuse/core";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  options: {
    type: Object,
    required: true,
  },
});

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const isDark = useDark();

const chartOptions = computed(() => {
  return _.merge(props.options, {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      bar: {
        borderRadius: 8,
        borderColor: isDark.value ? "#1D1D1D" : "#FFFFFF",
        hoverBorderColor: isDark.value ? "#1D1D1D" : "#FFFFFF",
        hoverBorderWidth: 2,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: isDark.value ? "#FFFFFF" : "#1D1D1D",
        },
      },
      y: {
        ticks: {
          color: isDark.value ? "#FFFFFF" : "#1D1D1D",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      }
    },
  });
});

</script>